import { Component, OnInit, isDevMode, Output, EventEmitter } from '@angular/core';
import { UserAddress, PickUpCenter, User } from 'src/app/_models';
import { UtilsService, UserService } from 'src/app/_services';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ZipCodeValidator } from 'src/app/_validators/zipcode.validator';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, BehaviorSubject } from 'rxjs';


declare const $ : any;

@Component({
  selector: 'app-user-address-modal',
  templateUrl: './user-address-modal.component.html',
  styleUrls: ['./user-address-modal.component.css']
})
export class UserAddressModalComponent implements OnInit {

  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  
  public address : UserAddress;
  public addAddressForm : FormGroup;
  public submitted : boolean;
  public pickUpCenters : PickUpCenter[];
  public pickUpCenter : boolean;
  public pickupCenterName : Observable<string>;
  private pickupCenterNameSubject : BehaviorSubject<string>;
  public showPickupCenterName : boolean;
  

  constructor(
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private zipCodeValidator: ZipCodeValidator,  
    private toastr : ToastrService,
    private users : UserService,
    private translate: TranslateService
  ) { 
    this.pickupCenterNameSubject = new BehaviorSubject<string>('');
    this.pickupCenterName = this.pickupCenterNameSubject.asObservable();
    this.pickUpCenters = this.utils.pickupCenters;
  }

  get f() { 
    return this.addAddressForm.controls; 
  }

  ngOnInit() {

    this.address = new UserAddress();

    this.addAddressForm = this.formBuilder.group({
      name: [this.address.address_name,  Validators.required],
      street: [this.address.address_street,  Validators.required],
      number: [this.address.address_number,  Validators.required],
      floor: [this.address.address_floor],
      door: [this.address.address_door],
      stair: [this.address.address_stair],
      zipCode: [this.address.zipcode,  Validators.required, this.zipCodeValidator.checkZipCode.bind(this.zipCodeValidator ) ],
      city: [this.address.city,  Validators.required],
      province: [this.address.province,  Validators.required],
      observ: [this.address.observ],
    });

    this.initForm();

  }
  
  initForm (){
    this.address = new UserAddress();
    this.addAddressForm.reset();
    this.pickUpCenter = false;   
    this.submitted = false;
  }

  setZipCode (){

    this.utils.getProvince(this.f.zipCode.value).subscribe(province => this.f.province.setValue(province))
    this.utils.getPickUpCenter(this.f.zipCode.value).subscribe( 
      pickUpCenter => { 
        if (parseInt(pickUpCenter) == 0){
          this.pickUpCenter = true;
          this.showPickupCenterName = false;
          this.addAddressForm.addControl('pickUpCenter', new FormControl('', Validators.required));
          this.pickupCenterNameSubject.next('');
        } else {
          this.pickUpCenter = false;
          this.showPickupCenterName = false;
          this.addAddressForm.removeControl('pickUpCenter');
          this.pickupCenterNameSubject.next(this.utils.getPickUpCenterName(pickUpCenter));
        }
      },
      error => {
        this.pickUpCenter = true;
        this.showPickupCenterName = false;
        this.addAddressForm.addControl('pickUpCenter', new FormControl('', Validators.required));
        this.pickupCenterNameSubject.next('');
      } 
    );
  }

  onSubmit(){
    
    this.submitted = true;

    if (this.addAddressForm.invalid){
      return;
    }

    try{

      this.address.address_name = this.f.name.value ?  this.f.name.value : '' ;
      this.address.address_street = this.f.street.value ? this.f.street.value : '';
      this.address.address_door = this.f.door.value ? this.f.door.value : '' ;
      this.address.address_floor = this.f.floor.value ? this.f.floor.value : '';
      this.address.address_number = this.f.number.value ? this.f.number.value : '';
      this.address.address_stair =  this.f.stair.value ? this.f.stair.value : '';
      this.address.address_type = 2
      this.address.city = this.f.city.value ? this.f.city.value : '';
      this.address.province = this.f.province.value ? this.f.province.value : '';
      this.address.observ = this.f.observ.value ? this.f.observ.value : '';
      this.address.zipcode = this.f.zipCode.value ? this.f.zipCode.value : '';
      this.address.isprimary = 0; 
  
      if (this.pickUpCenter) {
        this.address.centre_ClickRecull = this.f.pickUpCenter.value ;
      }       

      this.users.addAddress(this.address).subscribe( result => {
        this.notifyParent.emit();
      });

    }
    catch (ex) {
        if (isDevMode()){
          this.toastr.warning(ex);
        }
    }
    finally {
      this.initForm();
      $("#modal-afegir-adreca").modal('hide');
    }
    
  }

  onChangePickupCenter (){
   this.pickupCenterNameSubject.next(this.utils.getPickUpCenterName(this.f.pickUpCenter.value));
  }

}
